import { useEffect, useState } from "react";
import serializeUrl from "@utils/url-format";
import homeApi from "@features/home/helpers/homeApi";
import { ICartInput, PRODUCT_SLUG } from "@types";
import useRequestImmutable from "@shared/hooks/useRequestImmutable";
import { TabItems } from "types/card-tab";

export const useStaticSlider = (initialData: TabItems) => {
  const [activeTabTitle, setActiveTabTitle] = useState("");

  const activeCategoryId = initialData?.tabs![0]?.id as number;

  const { data } = useRequestImmutable(
    homeApi.getHomeCards(PRODUCT_SLUG.MOST_RATE_PRODUCT_MONETARY, {
      category_id: activeCategoryId as number,
    })
  );

  const firstData = () => {
    if (data?.data?.products) {
      const fetchedProductsCopy = data.data.products.map(
        (item: ICartInput) => ({
          ...item,
          is_buyBasket: item.in_cart,
        })
      );
      const copy = { ...initialData };
      const theIndex = copy.tabs?.findIndex(
        (tab) => tab.id === activeCategoryId
      );
      copy.tabs![theIndex || 0].products = fetchedProductsCopy;
      return copy;
    }
  };

  const [slidersData, setSlidersData] = useState<TabItems>(
    firstData() || initialData
  );

  useEffect(() => {
    if (data) {
      const fetchedProductsCopy = data.data.products.map(
        (item: ICartInput) => ({
          ...item,
          is_buyBasket: item.in_cart,
        })
      );
      setSlidersData((prev) => {
        const copy = { ...prev };
        const theIndex = copy.tabs?.findIndex(
          (tab) => tab.id === activeCategoryId
        );
        copy.tabs![theIndex || 0].products = fetchedProductsCopy;
        return copy;
      });
    }
  }, [data]);

  const activeTab =
    (slidersData?.tabs || [])?.find((tab) => tab.active) || null;

  useEffect(() => {
    if (activeTab?.title && !activeTabTitle) setActiveTabTitle(activeTab.title);
  }, [activeTab]);

  const showMoreLink = `/explore?${serializeUrl({
    ...slidersData?.parameter,
    ...(activeTab?.id !== "all" && {
      category_ids: activeTab?.id,
    }),
    ...(slidersData?.parameter?.is_free !== undefined && {
      is_free: slidersData?.parameter?.is_free ? "1" : "0",
    }),
  })}`;

  return {
    activeTabTitle,
    showMoreLink,
    activeTab,
    slidersData,
  };
};
